import { apiService, handleResponse } from '@/services/apiService';

export class UserRepository {
    async loginAdmin(credentials: { email: string; password: string }) {
        const response = await apiService.post(`/admin/login`, credentials);
        return handleResponse(response);
    }
    async logoutAdmin() {
        const response = await apiService.post(`/admin/logout`);
        return handleResponse(response);
    }
    async getUserAdmin() {
        const response = await apiService.get(`/v1/admin/user`);
        return handleResponse(response);
    }

    async login(credentials: { email: string; password: string }) {
        const response = await apiService.post(`/login`, credentials);
        return handleResponse(response);
    }
    async logout() {
        const response = await apiService.post(`/logout`);
        return handleResponse(response);
    }

    async getUser() {
        const response = await apiService.get(`/v1/user`);
        return handleResponse(response);
    }

    async register(userData: object) {
        const response = await apiService.post(`/register`, userData);
        return handleResponse(response);
    }

    async clearOrders() {
        const response = await apiService.post(`/v1/orders/clear`);
        return handleResponse(response);
    }

    // Mot de passe oublié - demande de lien de réinitialisation
    async forgotPassword(email: string) {
        const response = await apiService.post(`/forgot-password`, { email });
        return handleResponse(response);
    }

    // Réinitialisation du mot de passe avec token
    async resetPassword(resetData: { token: string; email: string; password: string; password_confirmation: string }) {
        const response = await apiService.post(`/reset-password`, resetData);
        return handleResponse(response);
    }

    // Activation de compte utilisateur
    async activateUserAccount(activationData: { token: string; email: string; password: string; password_confirmation: string; first_name: string; last_name: string }) {
        const response = await apiService.post(`/v1/activate-user-account`, activationData);
        return handleResponse(response);
    }

    // Activation de compte administrateur
    async activateAdminAccount(activationData: { token: string; email: string; password: string; password_confirmation: string; first_name: string; last_name: string }) {
        const response = await apiService.post(`/v1/activate-admin-account`, activationData);
        return handleResponse(response);
    }

    // Mot de passe oublié - demande de lien de réinitialisation - ADMIN
    async forgotPassword2(email: string) {
        const response = await apiService.post(`/v1/forgot-password`, { email });
        return handleResponse(response);
    }

    // Réinitialisation du mot de passe avec token - ADMIN
    async resetPassword2(resetData: { token: string; email: string; password: string; password_confirmation: string }) {
        const response = await apiService.post(`/v1/reset-password`, resetData);
        return handleResponse(response);
    }


    // Récupérer la liste des entreprises
    async getCompanies() {
        const response = await apiService.get(`/v1/companies`);
        return handleResponse(response);
    }

    // Récupérer la liste des utilisateurs d'une entreprise
    async getCompanyUsers(companyId: number) {
        const response = await apiService.get(`/v1/companies/${companyId}/users`);
        return handleResponse(response);
    }

    // Demande d'informations pour compte professionnel
    async requestProfessionalInfo(email: string) {
        const response = await apiService.post(`/v1/request-professional-info`, { email });
        return handleResponse(response);
    }

    // Récupérer des paramètres globaux
    async getGlobalParams(keys: string[]) {
        const response = await apiService.post(`/v1/global-params`, { keys });
        return handleResponse(response);
    }

    // Envoyer une demande de conseil
    async sendAdviceRequest(adviceData: { product_name: string; product_reference: string; message?: string }) {
        const response = await apiService.post(`/v1/advice-request`, adviceData);
        return handleResponse(response);
    }

    // Récupérer tous les utilisateurs (pour admin/storekeeper)
    async getAllUsers() {
        const response = await apiService.get(`/v1/users`);
        return handleResponse(response);
    }

    // Vérifier un badge NFC
    async checkBadge(uid: string) {
        const response = await apiService.post(`/v1/badge/check`, { uid });
        return handleResponse(response);
    }

    // Connexion par badge NFC
    async loginWithBadge(uid: string, pin: string) {
        const response = await apiService.post(`/v1/badge/login`, { uid, pin });
        return handleResponse(response);
    }
}
